import {Component, OnInit, EventEmitter, Output, Input, ViewChild, ElementRef} from '@angular/core';
import {
    NgForm,
    FormGroup,
    FormControl,
    FormArray,
    Validators,
    ValidatorFn,
    AsyncValidatorFn
} from '@angular/forms';
import { FormInlineRowComponent } from './../forms/form-inline-row';
import { UserService } from './user-service';
import { ModalService } from "../services/modal-service";
import { MessageComponent, BaseComponent } from './../common/common-components';
import { BankAccountService } from "./../accounts/bank-account-service";
import { DictionaryService } from '../services/dictionary-service';
import {catchError} from "rxjs/operators";
import {ValidationError} from "../services/http-service";
import {MessageService} from "../services/message-service";
import {of, combineLatest} from "rxjs";
declare var ga: any;
let _: any = require("lodash");

@Component({
    selector: 'dk-user-personal-data',
    template:  require("./user-personal-data.html"),
    //directives: [FormInlineRowComponent, MessageComponent],
    entryComponents: [FormInlineRowComponent],
    providers: [DictionaryService]
})

export class UserPersonalDataComponent extends BaseComponent implements OnInit {
    changeSuccess: boolean;
    changeFailure: boolean;
    showPEPDefinitions: boolean = false;
    needActivityType: boolean = false;
    countries: any[];
    activityTypes: any[];
    allActivityTypes: any[];
    activityType: string;
    privateCompanyTypes: any[];
    isPepTypes: any[];
    public errorMessageId: string;
    @Input() smsMode: boolean;
    @Output() smsModeChange = new EventEmitter<boolean>();

    idFile1: File;
    idFile2: File;

    idFile3: File;

    idFile4: File;

    @ViewChild('idFileInput1')
    idFileInput1: ElementRef;

    @ViewChild('idFileInput2')
    idFileInput2: ElementRef;

    @ViewChild('idFileInput3')
    idFileInput3: ElementRef;

    @ViewChild('idFileInput4')
    idFileInput4: ElementRef;

    isIdVerified: boolean = false;

    areIdDocumentsInVerification: boolean = false;

    showIdInputs: boolean = false;

    form: FormGroup = new FormGroup({
        PrivateOrNot: new FormControl(null),
        ActivityTypeID: new FormControl('', [Validators.required]),
        Email: new FormControl('', [Validators.required], [this.validateEmail()]),
        CompanyName: new FormControl('', this.requiredIfCompany()),
        TaxID: new FormControl('', this.requiredIfCompany()),
        FirstName: new FormControl('', [Validators.required]),
        LastName: new FormControl('', [Validators.required]),
        NationalityID: new FormControl('', [Validators.required]),
        CountryID: new FormControl('', Validators.required),
        City: new FormControl('', Validators.required),
        ZipCode: new FormControl('', Validators.required),
        Pesel: new FormControl('', [this.requiredIfPoland(), this.isInvalidPesel()]),
        BirthDate: new FormControl(''),
        DocumentNumber: new FormControl('', [Validators.required, this.isInvalidIdCard()]),
        DocumentExpirationDate: new FormControl(null),
        Street: new FormControl('', Validators.required),
        HouseNumber: new FormControl('', Validators.required),
        ApartmentNumber: new FormControl(''),
        InformationEmailAccepted: new FormControl(false, Validators.required),
        ProcessingDataAccepted: new FormControl(false, Validators.required),
        MarketingContactAccepted: new FormControl(false, Validators.required),
        Phone1Prefix: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(2)]),
        Phone1: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(11)]),
        Phone2: new FormControl(''),
        SmsCode: new FormControl(''),
        IsPep: new FormControl(null, [Validators.required])
    });

    constructor(private bankAccountService: BankAccountService,
        private modalService: ModalService,
        private userService: UserService,
        private dictionaryService: DictionaryService,
        private messageService: MessageService) {
        super();
    }

    load() {
        if (this.idFileInput1) {
            this.idFileInput1.nativeElement.value = null;
        }

        if (this.idFileInput2) {
            this.idFileInput2.nativeElement.value = null;
        }

        if (this.idFileInput3) {
            this.idFileInput3.nativeElement.value = null;
        }

        if (this.idFileInput4) {
            this.idFileInput4.nativeElement.value = null;
        }

        this.idFile1 = null;
        this.idFile2 = null;
        this.idFile3 = null;
        this.idFile4 = null;
        this.showIdInputs = false;

        this.userService.isPep().subscribe(data => {
            this.form.controls['IsPep'].setValue(data == null ? null : (data ? "true" : "false"));
        });

        this.userService.isIdVerified().subscribe(result => {
            this.isIdVerified = result;

            if (!this.isIdVerified) {
                this.showIdInputs = true;
            }
        })

        this.userService.areIdDocumentsInVerification().subscribe(result => {
            this.areIdDocumentsInVerification = result;
        })

        this.userService.account().subscribe(data => {
            this.needActivityType = !data.ActivityTypeID;
            if (data.ActivityTypeID) {
                this.activityType = this.allActivityTypes.filter(at => at.Id == data.ActivityTypeID)[0].Name;
            }

            if ( !data.Phone1Prefix  && data.Phone1 != null && data.Phone1 != '') {
                data.Phone1Prefix = data.Phone1.substring(1, 3);
                data.Phone1 = data.Phone1.substring(3, 20);
            }
            else {
                if ( !data.Phone1Prefix){
                    data.Phone1Prefix = '48';
                } else {
                    data.Phone1Prefix = data.Phone1Prefix.replace(/\+/g, "");
                }
            }
            


            this.initFormGroup(this.form, data);
            if (!data.CountryID || (data.CountryID < 0))
            {
                this.form.controls['CountryID'].setValue("167");
            }

            if (!data.NationalityID || (data.NationalityID < 0))
            {
                this.form.controls['NationalityID'].setValue("167");
            }
        });
    }

    ngOnInit() {
        this.form.controls['PrivateOrNot'].valueChanges.subscribe((value) => {
            if (value == "1") {
                this.form.controls['ActivityTypeID'].setValue("1");
            } else {
                this.form.controls['ActivityTypeID'].setValue(null);
            }
        });

        this.dictionaryService.countries().subscribe(countries => {
            this.countries = countries;
        });

        this.dictionaryService.activityTypes().subscribe(activityTypes => {
            this.activityTypes = activityTypes.filter(activityType => activityType.Id > 1);
            this.allActivityTypes = activityTypes;
            this.load();
        });

        this.privateCompanyTypes = [
            { "Id": "1" , "Name": "Konto prywatne" },
            { "Id": "2" , "Name": "Konto firmowe" }
        ];

        this.isPepTypes = [
            { "Id": "false" , "Name": "Nie" },
            { "Id": "true" , "Name": "Tak" }
        ];
    }

    submit() {
        if (this.smsMode == true)
        {
            return;
        }
        
        this.touchFormGroup(this.form);

        if (this.form.valid) {
            this.changeSuccess = false;
            this.changeFailure = false;
            this.bankAccountService.isAccountBankCodeChangeLocked().subscribe(isLocked => {
                if (isLocked) {
                    this.smsMode = true;
                    this.smsModeChange.emit(this.smsMode);
                    this.modalService.sendSmsCode();
                    this.form.controls['SmsCode'].setValue('');
                }
                else {
                    if (this.needActivityType) {
                        return this.userService.changeActivityType(this.form.controls["ActivityTypeID"].value).subscribe(() => {
                            return this.saveDetails();
                        });
                    } else {
                        return this.saveDetails();
                    }
                }
            });
        }
    }

    private saveDetails() {
        return this.userService.changePersonalData(this.form.value).subscribe(result => {
            this.continueSaveAfterPersonalData(result, false);
        });
    }

    back() {
        this.smsMode = false;
        this.smsModeChange.emit(this.smsMode);
    }

    confirmWithSms() {
        this.touchFormGroup(this.form);

        if (this.form.valid) {
            this.changeSuccess = false;
            this.changeFailure = false;
            let code = this.form.controls['SmsCode'].value;
            this.userService.changePersonalData(this.form.value, code).subscribe(result => {
                return this.continueSaveAfterPersonalData(result, true);
            }, error => {
                this.errorMessageId = error;
            });
            this.smsMode = false;
            this.smsModeChange.emit(this.smsMode);
            this.form.controls['SmsCode'].setValue('');
        };
    }

    continueSaveAfterPersonalData(result: boolean, showSmsFailure: boolean) {
        if (result) {
            return combineLatest([this.userService.changeIsPep(this.form.value.IsPep == "true"), this.saveIdFiles()])
                .subscribe(([isPepChanged, idFilesSaved]) => {
                    if (this.needActivityType) {
                        return this.userService.changeActivityType(this.form.controls["ActivityTypeID"].value).subscribe(() => {
                            this.changeSuccess = true;
                            ga('send', 'event', 'user', 'zapisano-dane-użytkownika', null, null, this.form.value);
                            this.load();
                        });
                    } else {
                        this.changeSuccess = true;
                        ga('send', 'event', 'user', 'zapisano-dane-użytkownika', null, null, this.form.value);
                        this.load();
                    }
                });
        } else {
            this.changeFailure = true;

            if (showSmsFailure) {
                this.errorMessageId = '1002';
            }
        }
    }

    public validateEmail(): AsyncValidatorFn {
        return (control: FormControl): Promise<{ [key: string]: any }> => {
            var result = new Promise(resolve => {
                if (control.value === "") {
                    resolve(null);
                }
                else {
                    this.userService.verifyEmail(control.value).subscribe(valid => {
                        if (!valid) {
                            resolve({
                                validateEmail: true
                            });
                        } else {
                            resolve(null);
                        }
                    });
                }
            });

            return result;
        };
    };

    public get isPrivatePerson() {
        return this.form.value.ActivityTypeID == 1;
    }

    public get isCompany() {
        return this.form.value.ActivityTypeID > 1;
    }

    public get isPoland() {
        return this.form.value.NationalityID == 167;
    }

    public requiredIfPrivatePerson() {
        return (control: FormControl) => {
            if (this.form) {
                if (this.isPrivatePerson) {
                    if ((control.value == null) || (control.value === '')) {
                        return {
                            requiredIfPrivatePerson: true
                        };
                    }
                }

                return null;
            }

            return null;
        };
    };

    public requiredIfPrivatePersonAndNotPoland() {
        return (control: FormControl) => {
            if (this.form) {
                if (this.isPrivatePerson && !this.isPoland) {
                    if ((control.value == null) || (control.value === '')) {
                        return {
                            requiredIfPrivatePerson: true
                        };
                    }
                }

                return null;
            }

            return null;
        };
    };

    public requiredIfNotPoland() {
        return (control: FormControl) => {
            if (this.form) {
                if (!this.isPoland) {
                    if ((control.value == null) || (control.value === '')) {
                        return {
                            requiredIfNotPoland: true
                        };
                    }
                }

                return null;
            }

            return null;
        };
    };

    public requiredIfPoland() {
        return (control: FormControl) => {
            if (this.form) {
                if (this.isPoland) {
                    if ((control.value == null) || (control.value === '')) {
                        return {
                            requiredIfPoland: true
                        };
                    }
                }

                return null;
            }

            return null;
        };
    };

    public requiredIfPrivatePersonAndPoland() {
        return (control: FormControl) => {
            if (this.form) {
                if (this.isPrivatePerson && this.isPoland) {
                    if ((control.value == null) || (control.value === '')) {
                        return {
                            requiredIfPrivatePersonAndPoland: true
                        };
                    }
                }

                return null;
            }

            return null;
        };
    };

    public requiredIfCompany() {
        return (control: FormControl) => {
            if (this.form) {
                if (this.isCompany) {
                    if ((control.value == null) || (control.value === '')) {
                        return {
                            requiredIfCompany: true
                        };
                    }
                }

                return null;
            }

            return null;
        };
    };

    public isInvalidPesel() {
        return (control: FormControl) => {
            let pesel = control.value;

            if (this.form) {
                if (this.isPoland) {
                    if (pesel) {
                        let weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
                        let sum = 0;
                        let controlNumber = parseInt(pesel.substring(10, 11));

                        for (let i = 0; i < weight.length; i++) {
                            sum += (parseInt(pesel.substring(i, i + 1)) * weight[i]);
                        }
                        sum = sum % 10;

                        if (((10 - sum) % 10) !== controlNumber) {
                            return {
                                isInvalidPesel: true
                            };
                        }
                    }
                }

                return null;
            }

            return null;
        };
    }

    public isInvalidIdCard() {
        return (control: FormControl) => {
            let idCardNumber = control.value;

            if (this.form) {
                if (this.isPoland) {
                    if (!this.validatePolishID(idCardNumber)) {
                        return {
                            isInvalidIdCard: true
                        }
                    }
                }

                return null;
            }

            return null;
        };
    }

    private validatePolishID(idCardNumber)
    {
        //Check length
        if (idCardNumber == null || idCardNumber.length != 9)
            return false;

        idCardNumber = idCardNumber.toUpperCase();
        let letterValues = [
            '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
            'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J',
            'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T',
            'U', 'V', 'W', 'X', 'Y', 'Z'];
        function getLetterValue(letter)
        {
            for (let j=0; j<letterValues.length; j++)
                if (letter == letterValues[j])
                    return j;
            return -1;
        }

        //Check seria
        for (let i=0; i<3; i++)
            if (getLetterValue(idCardNumber[i]) < 10)
                return false;
        //Check number
        for (let i=3; i<9; i++)
            if (getLetterValue(idCardNumber[i]) < 0 || getLetterValue(idCardNumber[i]) > 9)
                return false;

        //sprawdz cyfre controlna
        let sum = 7 * getLetterValue(idCardNumber[0]) +
            3 * getLetterValue(idCardNumber[1]) +
            1 * getLetterValue(idCardNumber[2]) +
            7 * getLetterValue(idCardNumber[4]) +
            3 * getLetterValue(idCardNumber[5]) +
            1 * getLetterValue(idCardNumber[6]) +
            7 * getLetterValue(idCardNumber[7]) +
            3 * getLetterValue(idCardNumber[8]);
        sum %= 10;

        if (sum != getLetterValue(idCardNumber[3]))
            return false;

        return true;
    }

    handleFileInput1(file) {
        this.idFile1 = file;
    };

    handleFileInput2(file) {
        this.idFile2 = file;
    };

    handleFileInput3(file) {
        this.idFile3 = file;
    };

    handleFileInput4(file) {
        this.idFile4 = file;
    };

    clearFileInput1() {
        this.idFile1 = null;
        this.idFileInput1.nativeElement.value = null;
    };

    clearFileInput2() {
        this.idFile2 = null;
        this.idFileInput2.nativeElement.value = null;
    };

    clearFileInput3() {
        this.idFile3 = null;
        this.idFileInput3.nativeElement.value = null;
    };

    clearFileInput4() {
        this.idFile4 = null;
        this.idFileInput4.nativeElement.value = null;
    };

    toggleShowIdInputs($event) {
        this.showIdInputs = !this.showIdInputs;
        $event.stopPropagation();
        return false;
    }

    saveIdFiles() {
        let files : File[] = [];
        if (this.idFile1 != null) {
            files.push(this.idFile1);
        }

        if (this.idFile2 != null) {
            files.push(this.idFile2);
        }

        if (this.idFile3 != null) {
            files.push(this.idFile3);
        }

        if (this.idFile4 != null) {
            files.push(this.idFile4);
        }

        if (files.length) {
            return this.userService.docUpload(files)
                .pipe(catchError((error, caught) => {
                    if (error instanceof ValidationError) {
                        this.messageService.errorByMessageId(error.messageId);
                    }

                    return of(false);
                }));
        }

        return of(true);
    }
}